import { render } from "./AdditionalInformation.vue?vue&type=template&id=062525ea&ts=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=ts"
export * from "./AdditionalInformation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__